/* ==========================================================================
   All Projects — Swiper slider init.
   Swiper 11 is loaded globally (deferred), so we wait for window.Swiper.
   Responsive slidesPerView; external prev/next arrows; watchOverflow hides the
   nav when everything fits (≤ columns → no slider). Per-instance + editor-safe.
   ========================================================================== */
(function () {
  'use strict';

  var instances = new WeakMap();

  function initOne(root) {
    if (!root) return;
    var swiperEl = root.querySelector('.all-projects__slider');
    if (!swiperEl || !window.Swiper) return;

    // tear down a previous instance (theme editor re-render)
    var existing = instances.get(root);
    if (existing) {
      try { existing.destroy(true, true); } catch (e) {}
      instances.delete(root);
    }

    var prevEl = root.querySelector('.all-projects__arrow--prev');
    var nextEl = root.querySelector('.all-projects__arrow--next');
    var colsDesktop = parseInt(swiperEl.getAttribute('data-columns-desktop') || '4', 10);
    if (isNaN(colsDesktop) || colsDesktop < 1) colsDesktop = 4;

    var swiper = new window.Swiper(swiperEl, {
      slidesPerView: 1.15,
      spaceBetween: 16,
      watchOverflow: true,
      loop: false,
      grabCursor: true,
      a11y: {
        prevSlideMessage: 'Previous projects',
        nextSlideMessage: 'Next projects',
      },
      navigation: {
        prevEl: prevEl || undefined,
        nextEl: nextEl || undefined,
        disabledClass: 'swiper-button-disabled',
        lockClass: 'swiper-button-lock',
      },
      breakpoints: {
        640: { slidesPerView: 2.2, spaceBetween: 16 },
        1000: { slidesPerView: 3.2, spaceBetween: 16 },
        // +0.2 so a sliver of the next card peeks in and reads as a slider
        1280: { slidesPerView: colsDesktop + 0.2, spaceBetween: 16 },
      },
    });

    instances.set(root, swiper);
  }

  function boot() {
    var roots = document.querySelectorAll('[data-all-projects]');
    if (!roots.length) return;

    var tries = 0;
    (function waitForSwiper() {
      if (window.Swiper || tries > 60) {
        for (var i = 0; i < roots.length; i++) initOne(roots[i]);
        return;
      }
      tries++;
      requestAnimationFrame(waitForSwiper);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-all-projects]');
    if (root) initOne(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-all-projects]');
    if (root && instances.get(root)) {
      try { instances.get(root).destroy(true, true); } catch (e) {}
      instances.delete(root);
    }
  });
})();
